import Link from 'next/link'

type LinkSectionProps = {
  title: string
  routes: { title: string; route: string; target?: string; id: string }[]
}

export const LinkSection = ({ title, routes }: LinkSectionProps) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="font-regular font-title text-sm text-gray-light">
        {title}
      </div>
      {routes.map(({ title, id, route, target }) => (
        <Link
          href={route}
          className="hover:underline focus:outline-none"
          key={id}
          target={target}
        >
          <div className="flex items-center gap-4 text-base font-medium text-mydra-black">
            <span>{title}</span>
          </div>
        </Link>
      ))}
    </div>
  )
}
